import { usePathname } from 'expo-router';
import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';
import { gaService } from '../services/ga.service';

/**
 * Tracks page_view for GA when route changes (web only)
 */
export function usePageViewTracking(pageTitle?: string) {
  const pathname = usePathname();
  const previousPathname = useRef<string | null>(null);

  useEffect(() => {
    if (Platform.OS !== 'web' || previousPathname.current === pathname) {
      return;
    }

    gaService.trackPageView(pathname, pageTitle);
    previousPathname.current = pathname;
  }, [pathname, pageTitle]);
}

